import { History } from 'history';
import { axiosApi } from 'utils/api';

export const apiCheckTenant = (name: string) => {
  return axiosApi().get('/tenant/check', {
    params: { name },
  });
};

export default {};
